import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=6af902b0&"
import script from "./AppInfo.vue?vue&type=script&lang=js&"
export * from "./AppInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports